import config from '@/services/Config';
import axios from 'axios';
import RequestConfig from '@/services/RequestConfig';

let restModel = 'retailer_lead';
let baseUrl = config.apiBaseUrl;

export default {
  getAll() {
    return axios.get(baseUrl + '/' + restModel, RequestConfig);
  },

  getById(id) {
    return axios.get(baseUrl + '/' + restModel + '/' + id, RequestConfig);
  },

  createOne(fields) {
    return axios.post(baseUrl + '/' + restModel, fields, RequestConfig);
  },

  update(id, fields) {
    return axios.put(baseUrl + '/' + restModel + '/' + id, fields, RequestConfig);
  },

  deleteById(id) {
    return axios.delete(baseUrl + '/' + restModel + '/' + id, RequestConfig);
  },

  getOwnRetailers() {
    return axios.get(baseUrl + '/' + restModel + '/own-retailers', RequestConfig);
  },

  getOwnConnectedCharities(){
    return axios.get(baseUrl + '/' + restModel + '/related-charities', RequestConfig);
  },

  getActivityForId(id) {
    return axios.get(baseUrl + '/' + restModel + '/' + id + '/activity', RequestConfig);
  },
}
